import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'stsSafeHtml'
})
export class StsSafeHtmlPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }

  constructor(private sanitized: DomSanitizer) {}


}
